import React from 'react';
import { observer } from 'mobx-react';

interface Props {
  companyName?: string;
  logoUrl?: string;
}

const CompanyLogo = (props: Props) => {
  const { companyName, logoUrl } = props;
  return (
    <div data-testid='company-logo'>
      {logoUrl ?
        <img
          className='pt-4 liability-coverage-svg login-page__logo'
          src={logoUrl}
          alt={companyName}
          aria-hidden
        />
        : companyName && <h2 className='pb-2 pt-2'>{companyName}</h2>
      }
    </div>
  );
};

export default observer(CompanyLogo);
